import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { appsPublicImg } from "../../../../../../../common/consts";
import { PresentBoxKey } from "../../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/ItemsCard/items/ItemClass/PresentBox";
import { RegisteredEnvelopeKey } from "../../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/ItemsCard/items/ItemClass/RegisteredEnvelope/RegisteredEnvelope";

export function MyOwnPresent({
    present,
    presentQuantity,
}: {
    present: PresentBoxKey | RegisteredEnvelopeKey;
    presentQuantity: number;
}) {
    const c = useStyles();

    return (
        <div className={c.outerContainer}>
            <Card className={c.card}>
                <img
                    src={`${appsPublicImg}item/${present}.png`}
                    className={c.img}
                />
                {presentQuantity > 1 && present !== "registered_envelope" && (
                    <div className={c.quantity}>× {presentQuantity}</div>
                )}
            </Card>
        </div>
    );
}
const useStyles = makeStyles({
    outerContainer: { marginTop: 15, display: "flex" },
    card: { display: "flex", alignItems: "center", padding: 10 },
    quantity: { marginLeft: 7, fontSize: "large" },
    img: { width: 40 },
});
